import React from 'react';

// BeachLAN icon set — stroke-based, 24×24 viewBox

export const UsersIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8.5" cy="7" r="3"/>
    <path d="M2 21c0-3.6 2.9-6.5 6.5-6.5S15 17.4 15 21"/>
    <circle cx="17.5" cy="8" r="2.25"/>
    <path d="M21.5 21c0-2.9-1.9-5.4-4.5-6.1"/>
  </svg>
);

export const TicketIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12a2 2 0 0 0 0-4V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a2 2 0 0 0 0 4v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2z"/>
    <line x1="12" y1="5" x2="12" y2="8" strokeDasharray="1.5 2"/>
    <line x1="12" y1="11" x2="12" y2="19" strokeDasharray="1.5 2"/>
  </svg>
);

export const PaymentIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="13" rx="2"/>
    <path d="M2 10h20"/>
    <circle cx="7" cy="15" r="1.25" fill="currentColor" stroke="none"/>
    <rect x="11" y="13.5" width="6" height="3" rx="1"/>
  </svg>
);

export const CheckInIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="5" height="5" rx="0.75"/>
    <rect x="16" y="3" width="5" height="5" rx="0.75"/>
    <rect x="3" y="16" width="5" height="5" rx="0.75"/>
    <line x1="4.5" y1="4.5" x2="6.5" y2="4.5"/>
    <line x1="4.5" y1="4.5" x2="4.5" y2="6.5"/>
    <line x1="17.5" y1="4.5" x2="19.5" y2="4.5"/>
    <line x1="19.5" y1="4.5" x2="19.5" y2="6.5"/>
    <line x1="4.5" y1="17.5" x2="6.5" y2="17.5"/>
    <line x1="4.5" y1="19.5" x2="4.5" y2="17.5"/>
    <path d="M13 3v4l2 2 4-4"/>
    <path d="M13 14h2v2h-2v2h2v2h2v-2h2v-2h-2v-2h2"/>
  </svg>
);

export const SeatIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 4h3a1 1 0 0 1 1 1v8H5V5a1 1 0 0 1 0-1z"/>
    <path d="M16 4h3a1 1 0 0 1 1 1v8h-4V5a1 1 0 0 1 0-1z"/>
    <path d="M5 13h14v3a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-3z"/>
    <path d="M8 19v2m8-2v2"/>
  </svg>
);

export const EventIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2"/>
    <path d="M8 21h8m-4-4v4"/>
    <path d="M7 7.5c2-2 5-2 7 0s5 2 7 0"/>
    <path d="M7 11.5c2-2 5-2 7 0"/>
  </svg>
);

export const MapPinIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.7 2 6 4.7 6 8c0 4.5 6 12 6 12s6-7.5 6-12c0-3.3-2.7-6-6-6z"/>
    <circle cx="12" cy="8" r="2"/>
  </svg>
);

export const WaveIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12c1.5-2 3-2 4.5 0s3 2 4.5 0 3-2 4.5 0 3 2 4.5 0"/>
    <path d="M2 17c1.5-2 3-2 4.5 0s3 2 4.5 0 3-2 4.5 0 3 2 4.5 0"/>
    <path d="M2 7c1.5-2 3-2 4.5 0s3 2 4.5 0 3-2 4.5 0 3 2 4.5 0"/>
  </svg>
);

// Navigation icons

export const DashboardIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="8" height="8" rx="1.5"/>
    <rect x="13" y="3" width="8" height="8" rx="1.5"/>
    <rect x="3" y="13" width="8" height="8" rx="1.5"/>
    <rect x="13" y="13" width="8" height="8" rx="1.5"/>
  </svg>
);

export const CalendarIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="16" rx="2"/>
    <path d="M3 10h18"/>
    <path d="M8 3v4m8-4v4"/>
    <circle cx="8" cy="15" r="1" fill="currentColor" stroke="none"/>
    <circle cx="12" cy="15" r="1" fill="currentColor" stroke="none"/>
    <circle cx="16" cy="15" r="1" fill="currentColor" stroke="none"/>
  </svg>
);

export const NavTicketIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12a2 2 0 0 0 0-4V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a2 2 0 0 0 0 4v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2z"/>
    <line x1="12" y1="5" x2="12" y2="19" strokeDasharray="2 2.5"/>
  </svg>
);

export const WalletIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="14" rx="2"/>
    <path d="M16 13a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" fill="currentColor" stroke="none"/>
    <path d="M22 10H6a2 2 0 0 1-2-2V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1"/>
  </svg>
);

export const MapIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 3L3 5v16l6-2 6 2 6-2V3l-6 2-6-2z"/>
    <path d="M9 3v16m6-14v16"/>
  </svg>
);

export const TrophyIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3h12v7a6 6 0 0 1-12 0V3z"/>
    <path d="M6 7H3a2 2 0 0 0 2 2"/>
    <path d="M18 7h3a2 2 0 0 1-2 2"/>
    <path d="M12 16v3m-4 2h8"/>
  </svg>
);

export const ScanIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7V4a1 1 0 0 1 1-1h3m10 0h3a1 1 0 0 1 1 1v3M3 17v3a1 1 0 0 0 1 1h3m10 0h3a1 1 0 0 0 1-1v-3"/>
    <line x1="3" y1="12" x2="21" y2="12" strokeWidth="2.5"/>
  </svg>
);

export const DiamondIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l3-5h12l3 5-9 11L3 9z"/>
    <path d="M3 9h18M9 4l-3 5 6 11 6-11-3-5"/>
  </svg>
);

export const NavUsersIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="7.5" r="3"/>
    <path d="M3 21c0-3.3 2.7-6 6-6s6 2.7 6 6"/>
    <circle cx="17" cy="8.5" r="2.25"/>
    <path d="M21 21c0-2.8-1.8-5.2-4.5-5.9"/>
  </svg>
);

export const LogsIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2"/>
    <line x1="8" y1="8" x2="16" y2="8"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
    <line x1="8" y1="16" x2="12" y2="16"/>
  </svg>
);

export const WhatsAppIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.87.5 3.62 1.45 5.15L2 22l5.1-1.54a9.85 9.85 0 0 0 4.94 1.33h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.13-2.9-7-1.87-1.87-4.36-2.88-7.02-2.88zm0 1.67c2.21 0 4.29.86 5.85 2.42a8.23 8.23 0 0 1 2.42 5.82c0 4.55-3.71 8.25-8.27 8.25a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.03.91.92-2.95-.2-.31a8.18 8.18 0 0 1-1.26-4.39c0-4.55 3.71-8.25 8.05-8.42z"/>
    <path d="M9.1 7.55c-.18-.4-.37-.4-.55-.41-.14-.01-.31-.01-.47-.01-.16 0-.42.06-.64.3-.22.24-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.16 1.65 2.64 4.08 3.6 2.02.8 2.43.64 2.87.6.44-.04 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.47-.28-.25-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.02-.38-1.94-1.2-.72-.64-1.2-1.42-1.34-1.66-.14-.24-.02-.38.1-.5.12-.12.27-.31.4-.47.12-.16.16-.27.24-.45.08-.18.04-.34-.02-.46-.06-.12-.5-1.27-.7-1.65z"/>
  </svg>
);

export const ClockIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M12 7v5l3.5 2"/>
  </svg>
);

export const InstagramIcon = ({ className = 'w-5 h-5' }) => {
  const gradId = React.useId();
  return (
    <svg className={className} viewBox="0 0 24 24">
      <defs>
        <radialGradient id={gradId} cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#FFDD55"/>
          <stop offset="10%" stopColor="#FFDD55"/>
          <stop offset="50%" stopColor="#FF543E"/>
          <stop offset="100%" stopColor="#C837AB"/>
        </radialGradient>
      </defs>
      <rect x="2" y="2" width="20" height="20" rx="6" fill={`url(#${gradId})`}/>
      <rect x="6.5" y="6.5" width="11" height="11" rx="3.5" fill="none" stroke="#fff" strokeWidth="1.75"/>
      <circle cx="12" cy="12" r="3.2" fill="none" stroke="#fff" strokeWidth="1.75"/>
      <circle cx="16.6" cy="7.4" r="1.1" fill="#fff"/>
    </svg>
  );
};

export const BingoIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="9" y1="3" x2="9" y2="21"/>
    <line x1="15" y1="3" x2="15" y2="21"/>
    <line x1="3" y1="9" x2="21" y2="9"/>
    <line x1="3" y1="15" x2="21" y2="15"/>
    <circle cx="6" cy="6" r="1.2" fill="currentColor" stroke="none"/>
    <circle cx="18" cy="18" r="1.2" fill="currentColor" stroke="none"/>
  </svg>
);

export const NewsletterIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2"/>
    <path d="M3 6.5l9 6 9-6"/>
  </svg>
);

export const CateringIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3v7a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V3"/>
    <path d="M8 12v9"/>
    <path d="M17 3c-1.5 0-3 1.5-3 4s1.5 4 3 4v10"/>
  </svg>
);

export const MonitorLinkIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="12" rx="2"/>
    <path d="M8 20h8"/>
    <path d="M12 16v4"/>
    <path d="M10 11l2-2 2 2"/>
    <path d="M12 9v4"/>
  </svg>
);

export const InfoIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <line x1="12" y1="11" x2="12" y2="16.5"/>
    <circle cx="12" cy="7.5" r="1" fill="currentColor" stroke="none"/>
  </svg>
);

export const ServerIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="6" rx="1.5"/>
    <rect x="3" y="14" width="18" height="6" rx="1.5"/>
    <circle cx="7" cy="7" r="0.75" fill="currentColor" stroke="none"/>
    <circle cx="7" cy="17" r="0.75" fill="currentColor" stroke="none"/>
  </svg>
);
